import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { LabelBase } from '/druid/Label.base';
import { getStyles } from '/druid/Label.styles';
import { ILabelProps, ILabelStyleProps, ILabelStyles } from '/druid/Label.types';

export const Label: React.FunctionComponent<ILabelProps> = styled<ILabelProps, ILabelStyleProps, ILabelStyles>(
  LabelBase,
  getStyles,
  undefined,
  {
    scope: 'Label',
  },
);
